import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {PersianKeyValue} from '../../model/SamanHealthFamilyModels';
import {Option, Response, StaticMethods} from '../../model/GeneralModels';
import {ListService} from '../../services/list.service';
import {GeneralService} from '../../services/general.service';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  Group = this.fb.group({
    stateID: ['', Validators.required],
    cityID: ['', Validators.required],
    gender: ['', Validators.required],
    firstName: ['', Validators.required],
    lastName: ['', Validators.required],
    birthday: ['', Validators.required],
    fathersName: ['', Validators.required],
    nationalCode: ['', Validators.required],
    mobile: ['', Validators.required],
    address: ['', Validators.required],
    email: ['', Validators.email]
  });
  states$: Option[] = [];
  cities$: Option[] = [];
  genderList: Option[] = [];
  cityID: number;

  constructor(private listServices: ListService, private fb: FormBuilder, private generalServices: GeneralService,
              private authService: AuthService) {
  }

  ngOnInit() {
    this.genderList[this.genderList.length] = new Option('مرد', 'MALE');
    this.genderList[this.genderList.length] = new Option('زن', 'FEMALE');
    this.Group.controls.mobile.patchValue(this.authService.decode().auth);
    this.listServices.getStateList('COMMON').subscribe((response: Response) => {
      if (response.success) {
        this.states$ = [];
        response.data.states.forEach(state => {
          this.states$[this.states$.length] = new Option(state.persianName, state.stateCode);
        });
      }
    });
    this.generalServices.getPersonalInfo().subscribe((response: Response) => {
      if (response.success) {
        if (response.data) {
          for (const key in response.data) {
            if (response.data.hasOwnProperty(key)) {
              if (this.Group.controls.hasOwnProperty(key)) {
                if (response.data[key] === 0) {
                  response.data[key] = '';
                }
                this.Group.controls[key].patchValue(response.data[key]);
              }
            }
          }
        }
        if (response.data.stateID) {
          this.Group.controls.stateID.patchValue(response.data.stateID);
          this.cityID = response.data.cityID;
          this.onStateChange();
        }
      }
    });
  }

  submit() {
    console.log(this.Group.value);
    console.log(this.Group.valid);
    if (this.Group.valid) {
      this.generalServices.submitPersonalInfo(this.Group.value).subscribe((response: Response) => {
        if (response.success) {
          StaticMethods.showMessage('اطلاعات با موفقیت ذخیره شد');
        }
      });
    }
  }

  onStateChange() {
    console.log(this.Group.controls.stateID.value);
    this.listServices.getCityList('COMMON', this.Group.controls.stateID.value).subscribe((response: Response) => {
      if (response.success) {
        this.cities$ = [];
        response.data.cities.forEach(city => {
          this.cities$[this.cities$.length] = new Option(city.persianName, city.cityCode);
        });
        if (this.cityID) {
          this.Group.controls.cityID.patchValue(this.cityID);
        } else {
          this.Group.controls.cityID.patchValue(this.cities$[0].value);
        }
      }
    });
  }
}
